/**
 * Template method to create a reducer based in an ACTION_KEY to user in simple modals.
 */
export default function (ACTION_KEY) {
    const initialState = () => ({
        isOpened: false,
        data: null,
        onSuccessCallback: null,
        error: null,
        loading: false,
    });
    return (state = initialState(), action) => {
        switch (action.type) {
            case `${ACTION_KEY}_OPEN`: {
                const { data, onSuccessCallback } = action.payload;
                return {
                    ...state,
                    isOpened: true,
                    data,
                    onSuccessCallback,
                };
            }
            case `${ACTION_KEY}_CLOSE`: {
                return initialState();
            }
            case `${ACTION_KEY}_PENDING`: {
                return {
                    ...state,
                    loading: true,
                    error: null,
                };
            }
            case `${ACTION_KEY}_REJECTED`: {
                return {
                    ...state,
                    loading: false,
                    error: action.payload,
                };
            }
            default:
                return state;
        }
    };
}
